angular.module('controllers').controller('discountCampaignController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, $http, Crud, $mdDialog, $route, $routeParams, $location) {
		$rootScope.path = '/discount-campaign';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'discount-campaign';
		$scope.pathTemplate = 'discounts/discountcampaigns';
		$scope.title = 'Campanii de reduceri';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		//$scope.minDate = new Date();
		//$scope.maxDate = new Date();
		var current_init_date = new Date();
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;

		$scope.sortType = 'discount_campaign_start';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
			'client_phone':{'label':'Telefon client', 'filter':1, 'filterType':'input'},
			'discount_campaign_type':{'label':'Tip campanie', 'filter':1, 'filterType':'select'},
			'discount_campaign_value_type':{'label':'Tip reducere', 'filter':1, 'filterType':'select'},
			'discount_campaign_value':{'label':'Valoare discount', 'filter':1, 'filterType':'input'},
			'discount_campaign_times':{'label':'Nr. de aplicari', 'filter':1, 'filterType':'select'},
			'discount_campaign_times_granted':{'label':'Nr. de reduceri acordate', 'filter':1, 'filterType':'input'},
			'discount_campaign_status':{'label':'Status campanie', 'filter':1, 'filterType':'select'},
			'discount_campaign_start':{'label':'Start campanie', 'filter':1, 'filterType':'input'},
			'discount_campaign_end':{'label':'End campanie', 'filter':1, 'filterType':'input'},
			'discount_campaign_reason':{'label':'Motiv discount', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.columns.discount_campaign_status.options = [
			{'id':'', 'value' : ''},
			{'id':0, 'value' : 'in curs'},
			{'id':1, 'value' : 'inchisa'}
		];

		$scope.additionals['discount_types'] = [
			{'id':'', 'value' : ''},
			{'id':0, 'value' : 'procent', 'mark' : '%'},
			{'id':1, 'value' : 'suma fixa', 'mark' : ''}
		];
		$scope.columns.discount_campaign_value_type.options = $scope.additionals['discount_types'];

		$scope.additionals['discount_campaign_types'] = [
			{'id':'', 'value' : ''},
			{'id':0, 'value' : 'Reducere one-time'},
			{'id':1, 'value' : 'Reducere multipla'}
		];
		$scope.columns.discount_campaign_type.options = $scope.additionals['discount_campaign_types'];

		if (angular.isUndefined($scope.additionals['discount_campaign_times'])) {
			$scope.additionals['discount_campaign_times'] = [];
		}
		$scope.additionals['discount_campaign_times'][0] = {'id':0, 'value' : 'nelimitat'};
		for (var i = 1; i <= 100; i++) {
			$scope.additionals['discount_campaign_times'][i] = {'id':i, 'value' : i};
		}
		$scope.columns.discount_campaign_times.options = $scope.additionals['discount_campaign_times'];

		$scope.additionals['content_type'] = 'form-urlencoded';

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);
		$scope.additionals['discount_campaign_type_string'] = JSON.stringify($scope.columns.discount_campaign_type.options);
		$scope.additionals['discount_campaign_value_type_string'] = JSON.stringify($scope.columns.discount_campaign_value_type.options);
		$scope.additionals['discount_campaign_times_string'] = JSON.stringify($scope.columns.discount_campaign_times.options);
		$scope.additionals['discount_campaign_status_string'] = JSON.stringify($scope.columns.discount_campaign_status.options);
		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

		/* get dependent fields */
		/*$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['discounts'] = data.discounts;

					/!*if (!angular.isUndefined($scope.columns.shipping_method_name)) {
						$scope.columns.shipping_method_name.options = [{id: '', value: ''}];
						angular.forEach(data.shippingMethods, function (item, key) {
							$scope.columns.shipping_method_name.options.push({
								id: item.shipping_method_name,
								value: item.shipping_method_name
							});
						});
					}*!/

				});
		}*/

		/* close field */
		$scope.additionals['closeField'] = function (paramName, paramId, model, key) {
			if (!angular.isUndefined(key)) {
				model[key][paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[key][paramId] = '';
				}
			} else {
				model[paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[paramId] = '';
				}
			}
		}

		$scope.additionals['clients'] = [];
		$scope.additionals['getClients'] = function (search) {

			if (!angular.isUndefined(search)) {
				if (search != '' && search != 'undefined' && search.length >= 2) {
					var pathClient = 'search=' + search;
				}
			}

			$scope.additionals['errors'] = {};
			if (!angular.isUndefined($scope.errors)) {
				$scope.errors['client_id'] = {};
			}
			if (!angular.isUndefined(pathClient) && pathClient != 'undefined') {
				return Crud.get($scope.path + '/getClients?' + pathClient)
					.then(function (data) {
						$scope.additionals['clients'] = data.data.clients;
						return data.data.clients;
					});
			} else {
				return [];
			}

		}

		$scope.additionals['changeDiscountCampaignType'] = function(modelData) {
			if(modelData.discount_campaign_type == 0) {
				modelData.discount_campaign_times = 1;
			}
		}

		$scope.additionals['function'] = function(ev, data) {
			$scope.additionals['selectedItemClientPhone'] = '';
			$scope.additionals['selectedItemClientPhoneSearch'] = '';

			if($scope.action == 'store' || $scope.action == 'update') {
				if (!angular.isUndefined(data.discount_campaign_start)) {

					if (data.discount_campaign_start != null) {
						data.discount_campaign_start_date = new Date(data.discount_campaign_start);

						var dateStart = data.discount_campaign_start.split(' ');
						data.discount_campaign_start_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateStart[1]);
					}
				} else {
					data.discount_campaign_start_date = current_init_date;
				}
				if (!angular.isUndefined(data.discount_campaign_end)) {

					if (data.discount_campaign_end != null) {
						data.discount_campaign_end_date = new Date(data.discount_campaign_end);

						var dateEnd = data.discount_campaign_end.split(' ');
						data.discount_campaign_end_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateEnd[1]);
					}
				}
			}

			if($scope.action == 'updatemultiple') {
				$scope.additionals['selectedItemClientPhoneMultiple'] = [];

				angular.forEach(data, function (item, index) {
					if (!angular.isUndefined(item.discount_campaign_start)) {

						if (item.discount_campaign_start != null) {
							item.discount_campaign_start_date = new Date(item.discount_campaign_start);

							var dateStart = item.discount_campaign_start.split(' ');
							item.discount_campaign_start_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateStart[1]);
						}
					} else {
						item.discount_campaign_start_date = current_init_date;
					}
					if (!angular.isUndefined(item.discount_campaign_end)) {

						if (item.discount_campaign_end != null) {
							item.discount_campaign_end_date = new Date(item.discount_campaign_end);

							var dateEnd = item.discount_campaign_end.split(' ');
							item.discount_campaign_end_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateEnd[1]);
						}
					}


				});
			}
		}

		$scope.additionals['functionResult'] = function(ev, data) {

		}

		/* close discount campaign */
		$scope.closeCampaignModel = function (ev, path, modelId, modelIndex) {
			$scope.additionals['invalid'] = '';
			$scope.modelData = {};
			$mdDialog.show({
				controller: DialogController,
				templateUrl: 'closeCampaignDialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {path: $scope.path, modelId: modelId, modelIndex: modelIndex, models:$scope.models, additionals: $scope.additionals}
			}).then();

			DialogController.$inject = ['$scope', '$mdDialog', 'path', 'modelId', 'modelIndex', 'models', 'additionals'];
			function DialogController($scope, $mdDialog, path, modelId, modelIndex, models, additionals) {
				$scope.path = path;
				$scope.cancel = function () {
					$mdDialog.cancel();
				};
				$scope.additionals = additionals;
				$scope.models = models;

				/* close campaign */
				$scope.closeCampaign = function () {
					$scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					var post = {};
					post['route'] = 'closeCampaign';
					post['id'] = modelId;
					Crud.post('form-urlencoded', post, $scope.path + '/closeCampaign')
						.success(function (data) {

							if (!angular.isUndefined($scope.models)) {
								$scope.models[modelIndex]['discount_campaign_status'] = 1;
							}
							$scope.errors = [];
							$mdDialog.cancel();
							$scope.additionals['buttonDisabled'] = false;

						}).error(function (data) {
							$scope.errors = data.errors;
							$mdDialog.cancel();
							$scope.additionals['buttonDisabled'] = false;
						});

				};
			}
		};

		/* close date time field */
		$scope.additionals['closeTime'] = function (ev, field, key) {
			if(ev.keyCode == 46) {
				if (angular.isUndefined(key)) {
					if (field == 'end_time') {
						$scope.modelData.discount_campaign_end_time = undefined;
					}
					if (field == 'start_time') {
						$scope.modelData.discount_campaign_start_time = undefined;
					}
				} else {
					if (field == 'end_time') {
						$scope.modelsData[key].discount_campaign_end_time = undefined;
					}
					if (field == 'start_time') {
						$scope.modelsData[key].discount_campaign_start_time = undefined;
					}
				}
			}
		}

		$scope.addDiscountCampaignModel = function (ev, path, modelId) {
			if (angular.isUndefined($scope.modelDataDiscountCampaign)) {
				$scope.modelDataDiscountCampaign = {};
			}
			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'adddiscountcampaign';
				$scope.errors = {};
				angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, 'slow');
				$scope.additionals['invalid'] = '';
				$scope.cancel = function () {
					$scope.modelDataDiscountCampaign = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};
				if (angular.isUndefined($scope.modelDataDiscountCampaign.discount_campaign_start)) {
					$scope.modelDataDiscountCampaign.discount_campaign_start_date = current_init_date;
				}
				$scope.addDiscountCampaign = function () {
					$scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					var post = $scope.modelDataDiscountCampaign;
					post['route'] = 'adddiscountcampaign';
					post['client_id'] = modelId;
					Crud.post('form-urlencoded', post, $scope.path + '/addDiscountCampaign')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
							}
							$scope.modelDataDiscountCampaign = {};
							$scope.errors = {};
							$scope.isLoading = false;
							$scope.controlSH = false;
							$scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.isLoading = false;
							$scope.errors = data.errors;
							$scope.additionals['buttonDisabled'] = false;
							if(data == null) {
								$rootScope.checkNetworkConnection();
							}
						});
				};
			}

			if($scope.mode_action == 'dialog') {
				if (angular.isUndefined($scope.modelDataDiscountCampaign)) {
					$scope.modelDataDiscountCampaign = {};
				}
				$scope.additionals['invalid'] = '';
				$scope.errors = {};
				$scope.action = 'adddiscountcampaign';

				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'discountCampaignDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						path: $scope.path,
						pathTemplate: $scope.pathTemplate,
						modelId: modelId,
						model: $scope.modelDataDiscountCampaign,
						additionals: $scope.additionals
					}
				}).then(function () {

				});
				DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'modelId', 'model', 'additionals'];
				function DialogController($scope, $mdDialog, path, pathTemplate, modelId, model, additionals) {
					$scope.path = path;
					$scope.pathTemplate = pathTemplate;
					$scope.modelDataDiscountCampaign = model;
					$scope.additionals = additionals;
					$scope.cancel = function () {
						$mdDialog.cancel();
					};
					if (angular.isUndefined($scope.modelDataDiscountCampaign.discount_campaign_start)) {
						$scope.modelDataDiscountCampaign.discount_campaign_start_date = current_init_date;
					}
					$scope.addDiscountCampaign = function () {
						$scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;
						var post = $scope.modelDataDiscountCampaign;
						post['route'] = 'adddiscountcampaign';
						post['client_id'] = modelId;
						Crud.post('form-urlencoded', post, $scope.path + '/addDiscountCampaign')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {

								}
								$scope.modelDataDiscountCampaign = {};
								$scope.isLoading = false;
								$mdDialog.hide();
								$scope.additionals['buttonDisabled'] = false;
							})
							.error(function (data) {
								$scope.isLoading = false;
								$scope.errors = data.errors;
								$scope.additionals['buttonDisabled'] = false;
								if(data == null) {
									$rootScope.checkNetworkConnection();
								}
							});
					};

				}
			}

		};

	}]
)
